import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';
import { DateTime } from 'luxon';
import TablaProductos from './TablaProductos';
import { v4 as uuidv4 } from 'uuid';

import {
    Box, Divider, Typography, Grid, Button, Container, FormControl, TextField,
    Paper, CircularProgress, Dialog, TableRow, TableCell, Table, TableContainer, DialogTitle,
    DialogContent, DialogActions, TableHead, TableBody, Autocomplete
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';

import { getDate, usuarios } from '../../utils/functions/Utils';

import FormatoValeEntrada from '../formatos/FormatoValeEntrada';
import { useTheme } from '@mui/material/styles'

function Devoluciones() {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);
    const theme = useTheme();

    const [entrada, setEntrada] = useState({
        tipoMovimiento: 'entrada', operacion: '', motivo: 'devolucion', descripcion: '', recibe: auth.user.name, estatus: '', observaciones: '', fecha: DateTime.now(), entrega: '', noOrden: ''
    });

    const [fecha, setFecha] = useState(DateTime.now());
    const [loading, setLoading] = useState(false);
    const [currentProduct, setCurrentProduct] = useState({ clave: '', nombre: '', cantidad: 0, precioUnitario: 0, printImage: true, costoUnitario: 0 });
    const [tempProducts, setTempProducts] = useState([]);
    const [products, setProducts] = useState([]);
    const [cotizacion, setCotizacion] = useState({});
    const [modalEdit, setModalEdit] = useState(false);

    const [showEntrada, setShowEntrada] = useState(false);
    const [motivo, setMotivo] = useState('devolucion');
    const [cliente, setCliente] = useState('');

    const [entrega, setEntrega] = useState('');
    const [recibe, setRecibe] = useState(auth.user.name);

    const [authKey, setAuthKey] = useState('');

    const [open, setOpen] = useState(false);

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

    useEffect(() => {
        if (!['Admin', 'Almacen'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Devoluciones';
    }, [auth])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } });
    }

    useEffect(() => {
        getData();
        document.body.style.backgroundColor = "#FFF";
        return () => {
            document.body.style.backgroundColor = theme.palette.background.default;
        }
    }, [])

    const getData = () => {
        setEntrada({
            recibe: auth.user.name,
            descripcion: `Devolución de productos al almacén solicitada por ...`,
            fecha: DateTime.now(),
            tipoMovimiento: 'entrada',
            operacion: '',
            motivo: 'devolucion',
            estatus: '',
            observaciones: '',
            entrega: ''
        })
    }

    const getUuid = () => { return uuidv4() };

    const handleAddProduct = ({ product }) => {
        let x = {};
        x.id = product._id;
        x.nombre = product.nombre;
        x.clave = product.clave;
        x.precioUnitario = product.precioUnitario;
        x.costoUnitario = product.costoUnitario;
        x.descripcion = product.descripcion;
        x.categoria = product.categoria;
        x.imagen = product.imagen;
        x.printImage = true;
        x.cantidad = 1;
        x.key = getUuid();
        setTempProducts(tempProducts => [...tempProducts, x]);
    }

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleAddList = () => {
        setProducts(products => [...products, ...tempProducts]);
        setTempProducts([]);
        setOpen(false);
    }

    useEffect(() => {
        updateCotizacion(products);
    }, [products])

    const updateCotizacion = (d) => {
        let subtotal = d.reduce(function (tot, arr) {
            return tot + arr.precioUnitario * arr.cantidad;
        }, 0);

        const iva = subtotal * 0.16;
        const total = subtotal + iva;

        setCotizacion({ subtotal: subtotal, iva: iva, total: total });
    }

    const handleDelete = (d, r) => {
        if (r < 2) {
            setProducts([]);
        } else {
            setProducts(products.filter(x => x.key !== d));
        }
    }

    const handleEdit = (d) => {
        setModalEdit(true);
        setCurrentProduct(d);
    }

    const handleCloseEdit = () => {
        setModalEdit(false);
        setCurrentProduct({ clave: '', nombre: '', cantidad: 0, precioUnitario: 0, printImage: true, costoUnitario: 0 });
    }

    const handleUpdateRefaccion = (d, e) => {
        setModalEdit(false);
        setProducts(products.map(r => r.key === e ? d : r));
    }

    useEffect(() => {
        setEntrada({ ...entrada, descripcion: `Devolución de productos al almacén, recibe ${auth.user.name} - entrega ${entrega}` });
    }, [entrega])

    const renderSearchModal = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'xxl'}
                open={open}
                className='exo2'
                scroll='paper'
                onClose={handleClose}>
                <DialogTitle>Agregar productos</DialogTitle>
                <DialogContent sx={{ width: '100%', padding: '0px' }}>
                    <Grid container >
                        <Grid item xs={12} lg={9} >
                            <TablaProductos height={500} cotizacion={true} onAddProduct={handleAddProduct} />
                        </Grid>
                        <Grid item xs={12} lg={3} style={{ padding: '0px 8px' }}>
                            <Divider className='my-3' textAlign="left">
                                <CustomChip variant='outlined' estatus='AUTORIZADO' label='Productos selecionados' className='text-bold' />
                            </Divider>
                            <TableContainer>
                                <Table>
                                    <TableHead sx={{ borderBottom: 'solid 1px black' }}>
                                        <TableRow>
                                            <TableCell size='small' align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                            <TableCell size='small' align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Refacción</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            tempProducts.length > 0 ? tempProducts.map((ref, i) => (
                                                <TableRow key={i}>
                                                    <TableCell size='small' align='center' sx={{ fontSize: '1em' }}>{ref.clave}</TableCell>
                                                    <TableCell size='small' align='center' sx={{ fontSize: '1em' }}>{ref.nombre}</TableCell>
                                                </TableRow>
                                            )) : <TableRow>
                                                <TableCell size='small' align='center' colSpan={3} sx={{ fontSize: '1em' }}>No ha selecionado ninguna refacción</TableCell>
                                            </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button color='success' variant='contained' onClick={() => handleAddList()}>Agregar productos &nbsp; <i className="fad fa-plus-circle"></i></Button>
                    <Button color='warning' variant='contained' onClick={() => handleClose()}>Cerrar &nbsp; <i className="fad fa-times"></i></Button>
                </DialogActions>
            </Dialog>
        )
    }

    const renderProducts = () => {
        return (
            <>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow hover >
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Cant.</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Producto</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {products.map((ref, i) => (
                                <TableRow hover key={i} onDoubleClick={() => handleEdit(ref)}>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.cantidad}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.nombre}</TableCell>
                                    <TableCell size='small' align='center'>
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                            <Button sx={{ minWidth: '110px' }} variant='contained' color='primary' className='m-1' onClick={() => handleEdit(ref)}>Editar &nbsp;&nbsp;<i className='fad fa-edit'></i></Button>
                                            <Button sx={{ minWidth: '50px' }} variant='contained' color='error' className='m-1' onClick={() => handleDelete(ref.key, products.length)}>&nbsp;<i className='fa fa-trash-alt'></i>&nbsp;</Button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <br />
            </>
        )
    }

    const renderEditModal = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={modalEdit}
                className='exo2'
                scroll='paper'
                onClose={handleCloseEdit}>
                <DialogTitle >Editar producto</DialogTitle>
                <DialogContent>
                    {currentProduct ?
                        <div>
                            <Grid container spacing={1}>
                                <Grid item sm={12} md={4}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled label="Clave" variant="outlined" value={currentProduct.clave} onChange={(e) => setCurrentProduct({ ...currentProduct, clave: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled label="Producto" variant="outlined" multiline value={currentProduct.nombre} onChange={(e) => setCurrentProduct({ ...currentProduct, nombre: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <FormControl sx={{ m: 1 }} style={{ display: 'flex' }}>
                                        <TextField label="Cantidad" variant="outlined" value={currentProduct.cantidad} onChange={(e) => setCurrentProduct({ ...currentProduct, cantidad: Number(e.target.value) })} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </div> : <div></div>}
                    <br />
                    <Grid item xs={12} sm={12} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
                        <Button variant='contained' color='primary' className='m-1 p-2' onClick={() => handleUpdateRefaccion(currentProduct, currentProduct.key)}>&nbsp;Actualizar &nbsp;&nbsp;<i className='fad fa-cogs' style={{ transform: 'scale(1.3)' }}></i>&nbsp;</Button>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleCloseEdit()}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleShowEntrada = () => {
        setShowEntrada(true);
    }

    const handleCloseEntrada = () => {
        setShowEntrada(false);
    }

    const handleEntrada = async (e) => {
        e.preventDefault();
        if (products.length < 1) {
            setApiRes(state => { return { ...state, show: true, message: 'No ha seleccionado ningún producto', severity: 'warning' } });
        } else {
            const tmp = {
                tipoMovimiento: 'entrada',
                motivo: motivo,
                entrada: {
                    fechaDeEntrada: fecha,
                    noFactura: entrada.noOrden,
                    recibe: recibe,
                    entrega: entrega,
                    devolucion: true,
                    infoDevolucion: {
                        cliente: cliente,
                        noSalida: entrada.noOrden,
                    }
                },
                descripcion: entrada.descripcion,
                observaciones: entrada.observaciones,
                productos: products,
                cotizacion: cotizacion,
                auth: auth.user.name,
                estatus: 'Consolidado',
            }

            try {
                const res = await axios.post('/api/inventories/', { inventory: tmp, authKey: authKey, user: auth.user });
                if (res.status === 200) {
                    setApiRes(state => { return { ...state, show: true, message: 'Entrada de producto registrada', severity: 'success' } });
                    setTimeout(() => {
                        navigate('/inventario/tablaInventario');
                    }, 800);
                }
            } catch (err) {
                setApiRes(state => { return { ...state, show: true, message: err.response.data.message, severity: 'error' } });
                console.log(err);
            }
        }
    }

    const modalEntrada = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={showEntrada}
                className='exo2'
                scroll='paper'
                onClose={handleCloseEntrada}>
                <DialogTitle>Validar entrada de productos al almacén</DialogTitle>
                <DialogContent>
                    <div>
                        <Grid container spacing={1}>
                            <Grid item sm={12}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField disabled label="Recibe" variant="outlined" value={entrada.recibe} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={12}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField disabled label="Fecha de solicitud" variant="outlined" value={getDate(fecha)} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={12}>
                                <FormControl sx={{ m: 1 }} style={{ display: 'flex' }}>
                                    <TextField label="Descripción" variant="outlined" value={entrada.descripcion} onChange={(e) => setEntrada({ ...entrada, descripcion: e.target.value })} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={12}>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow hover >
                                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Cant.</TableCell>
                                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {products.map((ref, i) => (
                                                <TableRow hover key={i}>
                                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.cantidad}</TableCell>
                                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.nombre}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                        <hr style={{ margin: '24px 0px' }} />
                        <form onSubmit={(e) => handleEntrada(e)}>
                            <Grid container spacing={1}>
                                <Grid item sm={12} >
                                    <p></p>
                                    <FormControl sx={{ m: 1, minWidth: 100, maxWidth: '500px' }} style={{ display: 'flex' }}>
                                        <TextField required type='password' label="Llave de verificación" variant="outlined" value={authKey} onChange={(e) => setAuthKey(e.target.value)} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start' }}>
                                    <Button variant='contained' color='primary' className='m-1 p-2' type='submit' >&nbsp;Confirmar devolución &nbsp;&nbsp;<i className='fad fa-badge-check' style={{ transform: 'scale(1.3)' }}></i>&nbsp;</Button>
                                </Grid>
                            </Grid>
                        </form>
                    </div>
                    <br />
                </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleCloseEntrada()}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleSearchVale = async () => {
        try {
            const res = await axios.get(`/api/deliveries/vale/${entrada.noOrden}`);
            if (res.status === 200) {
                setEntrada({ ...entrada, descripcion: `Devolución de productos al almacén, recibe ${auth.user.name} - entrega ${res.data.recibe}` });
                setEntrega(res.data.recibe);
                setProducts(res.data.productos);
                setCliente(res.data.cliente);
            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: err.response.data.message, severity: 'error' } });
            console.log(err);
        }
    }

    return (
        <Container maxWidth='xxl' style={{ marginTop: '10px' }}>

            {loading ?
                <Box style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '128px' }}>
                    <CircularProgress size='5em' color='primary' />
                </Box> :

                <Paper sx={{ padding: '24px 0px' }} elevation={3}>
                    <Container maxWidth='xl'>
                        <Box className='text-center' >
                            <Typography variant='h5' style={{ fontWeight: 700 }}>Devolución de productos</Typography>
                        </Box>

                        <Button size='small' variant='outlined' onClick={() => navigate('/inventario')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>

                        <Divider className='my-3' textAlign="left">
                            <CustomChip variant='outlined' estatus='AUTORIZADO' label='Datos de la entrada' className='text-bold' />
                        </Divider>

                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6} lg={3}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <Autocomplete
                                        disablePortal
                                        freeSolo={true}
                                        onInputChange={(event, newInputValue) => setRecibe(newInputValue)}
                                        inputValue={recibe}
                                        options={usuarios}
                                        renderInput={(params) => <TextField {...params} label='Recibe' required />}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={3}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField disabled label="Tipo de Movimiento" variant="outlined" value={entrada.tipoMovimiento} onChange={(e) => setEntrada({ ...entrada, tipoMovimiento: e.target.value })} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={3}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <DatePicker
                                        label="Fecha de devolución"
                                        format="dd/MM/yyyy"
                                        value={fecha}
                                        onChange={(newValue) => setFecha(newValue)}
                                        slotProps={{ textField: { variant: 'outlined' } }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={3}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField disabled label="Motivo" variant="outlined" value={motivo} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <Autocomplete
                                        disablePortal
                                        freeSolo={true}
                                        onInputChange={(event, newInputValue) => setEntrega(newInputValue)}
                                        inputValue={entrega}
                                        options={usuarios}
                                        renderInput={(params) => <TextField {...params} label='Entrega' required />}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6} lg={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="# Vale de salida" variant="outlined" value={entrada.noOrden} onChange={(e) => setEntrada({ ...entrada, noOrden: e.target.value })} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={4} style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} >
                                    <Button variant="contained" size='large' color="info" onClick={() => handleSearchVale()}>Buscar # Vale &nbsp; <i className="fad fa-search"></i></Button>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField multiline label="Descripción" variant="outlined" value={entrada.descripcion} onChange={(e) => setEntrada({ ...entrada, descripcion: e.target.value })} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={12} md={6}>
                                <FormControl sx={{ m: 1 }} style={{ display: 'flex' }}>
                                    <TextField multiline label="Observaciones" variant="outlined" value={entrada.observaciones} onChange={(e) => setEntrada({ ...entrada, observaciones: e.target.value })} />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <br />

                        <Grid container spacing={3} sx={{ my: 1 }}>
                            <Grid item xs={12} md={4}>
                                <Button size='large' variant="contained" color="primary" onClick={handleOpen}>Agregar productos &nbsp; <i className="fad fa-plus-circle"></i></Button>
                            </Grid>
                        </Grid>

                        <Divider className='my-3' textAlign="center">
                            <CustomChip variant='outlined' estatus='AUTORIZADO' label='Productos' className='text-bold' />
                        </Divider>

                        {renderProducts()}

                        <Grid container >
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'end' }}>
                                <Button size='large' variant="contained" color="secondary" onClick={handleShowEntrada}>Validar productos &nbsp; <i className="fad fa-sign-in"></i></Button>
                            </Grid>
                        </Grid>
                    </Container>
                    <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
                </Paper>
            }

            {loading ? <></> :
                <Container maxWidth='xl'>
                    <FormatoValeEntrada recibe={entrada.recibe} productos={products} entrega={entrega} fechaDeEntrada={fecha} motivo={motivo} company={auth.user.company} />
                </Container>
            }

            {renderSearchModal()}

            {renderEditModal()}

            {modalEntrada()}
        </Container>
    );
}

export default Devoluciones;